module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_8003.e93aa4e3.png";